<script setup>
import WhatsAppTemplateParser from 'dashboard/components-next/whatsapp/WhatsAppTemplateParser.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  template: {
    type: Object,
    default: () => ({}),
  },
  // The same picker is reused as a fallback-template selector inside the
  // schedule modal (ReplyBox#showScheduleTemplatePicker); scheduling from
  // there makes no sense, so callers opt in explicitly.
  showScheduleOption: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['sendMessage', 'scheduleMessage', 'resetTemplate']);

const handleSendMessage = payload => {
  emit('sendMessage', payload);
};

const handleScheduleMessage = payload => {
  emit('scheduleMessage', payload);
};

const handleResetTemplate = () => {
  emit('resetTemplate');
};
</script>

<template>
  <div class="w-full">
    <WhatsAppTemplateParser
      :template="template"
      @send-message="handleSendMessage"
      @schedule-message="handleScheduleMessage"
      @reset-template="handleResetTemplate"
    >
      <template
        #actions="{ sendMessage, scheduleMessage, resetTemplate, disabled }"
      >
        <footer class="flex gap-2 justify-end">
          <NextButton
            faded
            slate
            type="reset"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.GO_BACK_LABEL')"
            @click="resetTemplate"
          />
          <NextButton
            v-if="showScheduleOption"
            faded
            slate
            type="button"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.SCHEDULE_LABEL')"
            :disabled="disabled"
            @click="scheduleMessage"
          />
          <NextButton
            type="button"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.SEND_MESSAGE_LABEL')"
            :disabled="disabled"
            @click="sendMessage"
          />
        </footer>
      </template>
    </WhatsAppTemplateParser>
  </div>
</template>
